export default __webpack_public_path__ + "img/pix-negative.3583ebb.svg";